import { render, staticRenderFns } from "./MarqetaCardActivationSuccess.vue?vue&type=template&id=4e2aa6b7&scoped=true"
import script from "./MarqetaCardActivationSuccess.vue?vue&type=script&lang=js"
export * from "./MarqetaCardActivationSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2aa6b7",
  null
  
)

export default component.exports